import React, {useState, useEffect, Fragment, useContext} from 'react';
import styled from '@emotion/styled'
import { css } from '@emotion/react'
import { Button, Tooltip, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, IconButton }from '@mui/material';

import GetAppRoundedIcon from '@mui/icons-material/GetAppRounded';

import useTableStore from '../../../store/table';

// table context
import { useTableId } from '../../../contexts/TableId';

import { ActionButton } from '../../Common';

import { downloadFile } from '../../util';

const ExportCsvComponent = ({ active }) => {
  const [loading, setLoading] = useState(false);

  const tableFinalQueryString = useTableStore(state => state.tableFinalQueryString);

  const tableId = useTableId();

  let queryString = tableFinalQueryString[tableId];

  console.log(queryString, "tableFinalQueryString");

  const exportFile = async () => {
    setLoading(true);
    try {
      await downloadFile({url: `${tableId}/export?${queryString}`});
    } catch(e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  }

  return (
    <Tooltip title="Export CSV">
      <ActionButton color="icon" variant="outlined" disabled={!active} onClick={exportFile} loading={loading} ><GetAppRoundedIcon /></ActionButton>
    </Tooltip>
  )
};

export default ExportCsvComponent;